export const loadDetailData = async (primaryRequest, secondaryRequests) => {
    const secondaryResults = secondaryRequests.map(request =>
        Promise.resolve(request).then(
            () => false,
            () => true
        )
    );
    const [, ...secondaryFailures] = await Promise.all([
        primaryRequest,
        ...secondaryResults
    ]);

    return secondaryFailures.some(Boolean);
};
